import * as Models from "../ts/rlAdmin.models";
import * as d3 from "d3";
import * as moment from "moment";
import { TitleCoverageController } from "../ts/rlAdmin.controllers";

export function RLTitleCoverageChart() {
    var directive: ng.IDirective = {
        replace: true,
        require: "^ngController",
        template: require("/assets/app/templates/title-coverage-chart.html"),
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: TitleCoverageController) => {
            var chart = new TitleCoverageChart(element[0], controller);

            scope.$watchCollection(() => controller.normalizedWindows,
                (newValue, oldValue) => {
                    if (newValue != null && newValue.length > 0) {
                        chart.SetData();
                    }
                });

        }
    };
    return directive;
}


class TitleCoverageChart {

    margin: {
        top: number;
        right: number;
        bottom: number;
        left: number;
    };
    width: number;
    height: number;
    colorScale: d3.scale.Ordinal<string, string>;
    xScale: d3.time.Scale<number, number>;
    yScale: d3.scale.Linear<number, number>;
    xAxis: d3.svg.Axis;
    yAxis: d3.svg.Axis;
    colorLookup: { [valueID: number]: string };

    constructor(private container: HTMLElement, private ctrl: TitleCoverageController) {

        this.colorScale = d3.scale.category20();
        this.colorLookup = {};

        this.Setup();
    }

    Setup() {

        this.margin = { top: 20, right: 20, bottom: 30, left: 40 };
        this.width = $(this.container).innerWidth() - this.margin.left - this.margin.right;
        this.height = 600 - this.margin.top - this.margin.bottom;

        this.xScale = d3.time.scale().range([0, this.width]);
        this.yScale = d3.scale.linear().range([this.height, 0]).domain([0, 0]);

        this.xAxis = d3.svg.axis()
            .scale(this.xScale)
            .orient("bottom")
            .tickFormat(d3.time.format("%b %y"));

        this.yAxis = d3.svg.axis()
            .scale(this.yScale)
            .orient("left")
            .tickFormat(d3.format(".2s"));

        var svg = d3.select(this.container).select("svg#chart-svg")
            .attr("width", this.width + this.margin.left + this.margin.right)
            .attr("height", this.height + this.margin.top + this.margin.bottom);

        svg.select("g.main").attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");

        var gMain = d3.select(this.container).select("svg#chart-svg g.main");

        gMain.select("g.x.axis")
            .attr("transform", "translate(0," + this.height + ")")
            .call(this.xAxis);

        gMain.select("g.y.axis")
            .call(this.yAxis)
            .append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 6)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .text("Avg Title Count");
    }


    SetData() {

        var startMoment = moment(this.ctrl.filterModel.startDate).utc();
        var endMoment = moment(this.ctrl.filterModel.endDate).utc();

        var fivePercent = { seconds: Math.abs(endMoment.unix() - startMoment.unix()) * 0.05 };

        startMoment = startMoment.clone().subtract(fivePercent);
        endMoment = endMoment.clone().add(fivePercent);

        var dataCount = this.ctrl.normalizedWindows.length;
        this.xAxis.ticks(dataCount);

        this.xScale.domain([startMoment.toDate(), endMoment.toDate()]);

        var maxSumCount = d3.max(this.ctrl.normalizedWindows, (win) => d3.sum(win.windowCounts.map((count) => count.count)));
        this.yScale.domain([0, maxSumCount]);

        var valueIDs = _(this.ctrl.windows).map((win) => win.windowCounts.map((count) => count.valueID)).flatten<number>().value();
        this.colorScale.domain(<string[]><any>[d3.min(valueIDs), d3.max(valueIDs)]);
        this.colorLookup = {};
        valueIDs.forEach((id) => { this.colorLookup[<number>id] = this.colorScale(<string><any>id); });

        this.Render();
    }

    Render() {
        var self = this;

        var gMain = d3.select(this.container).select("svg#chart-svg g.main");

        gMain.select("g.x.axis")
            .call(this.xAxis);

        gMain.select("g.y.axis")
            .call(this.yAxis);

        var barsData = gMain.select("g.bars").selectAll("g.bar").data(this.ctrl.normalizedWindows);

        barsData.enter().append("g").classed("bar", true);
        barsData.attr("transform", (d: Models.IPropertyCoverageWindow, i: number) => "translate(" + this.xScale(moment(d.startDate).toDate()) + ",0)");
        barsData.exit().remove();

        var rectData = gMain.selectAll("g.bars g.bar").selectAll("rect").data((d: Models.IPropertyCoverageWindow) => d.windowCounts, (d2: Models.IPropertyCoverageWindowCount) => d2.valueID.toString());

        var rectWidth = (self.width / self.ctrl.normalizedWindows.length) * .9 * .6;

        rectData.enter().append("rect").attr("x", (rectWidth / 2) * -1).attr("width", rectWidth).attr("height", 0).append("title");
        rectData.each(function (d: Models.IPropertyCoverageWindowCount) {
            var rect = d3.select(this);
            var coverageWindow = <Models.IPropertyCoverageWindow>d3.select(rect.node().parentNode).datum();
            rect.transition()
                .duration(200)
                .attr("y", (d: Models.IPropertyCoverageWindowCount) => self.yScale(d3.sum(coverageWindow.windowCounts.filter((win) => win.valueID <= d.valueID).map(win => win.count))))
                .attr("height", (d: Models.IPropertyCoverageWindowCount) => self.yScale(0) - self.yScale(d.count));
            rect.attr("x", (rectWidth / 2) * -1)
                .attr("width", rectWidth)
                .style("fill", (d: Models.IPropertyCoverageWindowCount) => self.colorLookup[d.valueID])
                .select("title")
                .text((d: Models.IPropertyCoverageWindowCount) => d.value + ": " + d.count);
        });
        rectData.exit().remove();
    }
}
